import config from '../config';

export default class RequestUtil {
  private static BASE_URL = config.API_BASE_URL;

  private static DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
  };

  public static get(path: string, headers?: RequestInit) {
    const options = this.generateOptions('GET', null, headers);
    return fetch(`${this.BASE_URL}/${path}`, options).then(this.handleResponse);
  }

  public static post(path: string, body: Record<string, unknown>, headers?: RequestInit) {
    const options = this.generateOptions('POST', body, headers);
    return fetch(`${this.BASE_URL}/${path}`, options).then(this.handleResponse);
  }

  private static generateOptions(method = 'GET', body: null | Record<string, unknown> = null, headers = {}) {
    return {
      method,
      ...(!body ? {} : { body: JSON.stringify(body) }),
      headers: {
        ...this.DEFAULT_HEADERS,
        ...headers,
      },
    };
  }

  private static handleResponse(response: Response) {
    if (response.status !== 200) {
      throw new Error(response.statusText);
    }
    return response.json();
  }
}
